import { isNilOrEmptyString } from 'ramda-extension';

import { cleanse } from 'utils';

import { REQUEST_SIZE_CAMPAIGN_MANAGEMENT } from './constants';

export const paramsFactory = (campaignId, userRole, formData, sort) => {
	return cleanse({
		queryParams: {
			page: 0,
			size: REQUEST_SIZE_CAMPAIGN_MANAGEMENT,
			sort,
		},
		body: {
			campaignId,
			userRole,
			orgStruct: {
				channelId: formData.channel,
				regionId: formData.region,
				agencyIds: [formData.agency],
				manager: formData.manager,
				seller: formData.seller,
				ppz: formData.ppz,
			},
			personIn: formData.personIn,
			businessIn: formData.businessIn,
			clientSurname: formData.surname,
			clientName: formData.firstName,
			businessName: formData.businessName,
			municipality: formData.municipality,
			zipCode: formData.zipCode,
			policyNo: formData.policyNumber,
			policyAgentSellerName: formData.policyAgent,
			productId: formData.product,
			assignLevel: formData.assignLevel,
			policyEndMonth: formData.policyEndDate,
			printTypeId: formData.printType,
			solutionStateIds: !isNilOrEmptyString(formData.contactState) ? [Number(formData.contactState)] : undefined,
		},
	});
};
